module.exports = __webpack_public_path__ + "static/media/IST.92d6d8c5.png";